import { render, staticRenderFns } from "./InstallmentBatchTypes.vue?vue&type=template&id=4a2888b6&"
import script from "./InstallmentBatchTypes.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports